// Replace hostname in yotpo APP reviews carousel section link href based on current hostname

window.addEventListener('load', function() {
    const carousel = document.querySelector('#yotpo-reviews-carousel-widget');
    if (carousel) {
        const links = carousel.querySelectorAll('.yotpo-reviews-carousel-seo-link-button');
        links.forEach(link => {
            if (link) {
                const url = new URL(link.href);

                if (window.location.hostname === 'zh.wnp.com.hk') {
                    url.hostname = 'zh.wnp.com.hk';
                } else {
                    url.hostname = 'wnp.com.hk';
                }

                link.href = url.toString();
            }
        });
    }
});
